module.exports = __webpack_public_path__ + "img/2.965b4e65.jpg";